import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 3rem;
  gap: 1rem;
  overflow-y: auto;
`;
